export const LICENSE_EXCEPTION_TYPES = {
  LICENSE_NOT_FOUND: 'LICENSE_NOT_FOUND',
  FEATURE_NOT_ACTIVE: 'FEATURE_NOT_ACTIVE',
  FEATURE_NOT_ENABLED: 'FEATURE_NOT_ENABLED',
  FEATURE_LIMIT_EXHAUSTED: 'FEATURE_LIMIT_EXHAUSTED',
  SIMULTANEOUS_LIMIT_EXHAUSTED: 'SIMULTANEOUS_LIMIT_EXHAUSTED',
};
